export default __webpack_public_path__ + "src/assets/giveth-logo.9a07dc2a274a09d9fd8290bfc60b8ad3.svg";